import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { ViewportProvider } from './context/ViewportContext';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './state';



ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ViewportProvider>
          <App />
        </ViewportProvider>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
